module.exports = __webpack_public_path__ + "assets/LogoGameScreen@2x.c029874878f31ba0f471a38951afd762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/logo/LogoGameScreen@2x.png
// module id = 753
// module chunks = 0